import Home from "../src/pages/Home";

function App() {
  return <Home />;
}

export default App;